import type { ReportTableCell } from '@erp/shared-types';

import type { RebateExportCell } from './rebateExportTypes';
import { parseRebateExportCell } from './parseRebateExportCell';

export function isNonCurrencyFormattedCode(
  value: unknown,
  formattedValue: unknown,
): formattedValue is string {
  return (
    value === 0 &&
    typeof formattedValue === 'string' &&
    formattedValue !== '' &&
    formattedValue !== '-' &&
    formattedValue !== '$0.00' &&
    !formattedValue.startsWith('$')
  );
}

export function isCurrencyFormatted(formatted: string): boolean {
  return (
    formatted.startsWith('$') ||
    formatted.startsWith('($') ||
    formatted.includes('$(')
  );
}

export function kindForNumericHeader(header: string): 'currency' | 'number' {
  return header.includes('%') ? 'number' : 'currency';
}

export function cellFromReportTableCell(
  cell: ReportTableCell | undefined,
  header: string,
): RebateExportCell {
  if (!cell) {
    return { value: null, kind: 'empty' };
  }
  if (isNonCurrencyFormattedCode(cell.value, cell.formattedValue)) {
    return { value: cell.formattedValue, kind: 'text' };
  }
  if (typeof cell.value === 'number' && !Number.isNaN(cell.value)) {
    return {
      value: cell.value,
      kind: kindForNumericHeader(header),
    };
  }
  return parseRebateExportCell(cell.formattedValue);
}

export function unwrapDownloadCsvCell(cellValue: unknown): unknown {
  if (
    cellValue &&
    typeof cellValue === 'object' &&
    'value' in cellValue &&
    'formattedValue' in cellValue
  ) {
    const formatted = (cellValue as { formattedValue: unknown }).formattedValue;
    if (isNonCurrencyFormattedCode(cellValue.value, formatted)) {
      return formatted;
    }
    return cellValue.value;
  }
  return cellValue;
}
